import React from "react";
import { Chart } from "react-google-charts";

const data = [
  ["Country", "Popularity"],
  ["Germany", 200],
  ["United States", 300],
  ["Brazil", 400],
  ["Canada", 500],
  ["France", 600],
  ["India", 700],
];

const GeoChart = () => {
  return (
    <Chart
      chartType="GeoChart"
      width="100%"
      height="400px"
      data={data}
      options={{
        colorAxis: { colors: ["#e6f2ff", "#0077b3"] }, // Customize colors
      }}
    />
  );
};

export default GeoChart;